import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useUser } from './use-user.hook'
import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { EUserRoles } from 'src/types'
import AuthDataService from 'src/services/auth.service'

const useAuth = () => {
  const navigate = useNavigate()
  const [tokenValid, setAccessTokenValid] = useState(true)
  const { data: user, isSuccess, isFetching, isLoading } = useUser()
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
  const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)

  useEffect(() => {
    if ((isSuccess && !user && !isFetching && accessToken) || !tokenValid) {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)

      navigate(ROUTES.LOGIN)
    }
  }, [isSuccess, user, navigate, isFetching, accessToken, tokenValid])

  useEffect(() => {
    const handleRefreshTokenValid = async () => {
      let refreshTokenStatus = null

      if (refreshToken) {
        refreshTokenStatus = await AuthDataService.validateToken(refreshToken)
      }

      return refreshTokenStatus
    }

    handleRefreshTokenValid().then((data) => {
      if (data) {
        if (typeof data.status === 'boolean') {
          setAccessTokenValid(data.status)
        }
      }
    })
  }, [refreshToken, isFetching])

  return {
    isAuthenticated: !!user || !!accessToken,
    isSuperadmin: user ? user?.roles.includes(EUserRoles.superadmin) : !!accessToken,
    isLoading: isLoading || !user,
  }
}

export { useAuth }
